import { post } from "app/utils/axios/kheti";
export interface BasicResponse {
  message: string;
}
const saveUserHistory = async (
  farmer_id: number,
  plantix_id: string,
  crop_id: number,
  disease_id: number
) => {
  try {
    const response = await post<BasicResponse>(`plantix/v1/history`, {
      farmer_id,
      plantix_id,
      crop_id,
      disease_id,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export default saveUserHistory;
